// Copyright (c) StrangeBee 2024

import { classList } from '@Helpers/className';
import { Table } from 'antd';
import { TableProps } from 'antd/lib/table';
import React, { ReactElement } from 'react';

import './THTable.scss';

type AntTable = TableProps<any>;

interface THTableProps {
    dataSource: AntTable['dataSource'];
    columns: AntTable['columns'];
    loading?: AntTable['loading'];
    scroll?: AntTable['scroll'];
    rowSelection?: AntTable['rowSelection'];
    className?: string;
    rowKey?: AntTable['rowKey'];
    expandable?: AntTable['expandable'];
    title?: AntTable['title'];
    size?: AntTable['size'];
}

const defaultScroll = { x: 'auto' };

const THTable = ({
    dataSource,
    columns,
    loading,
    rowSelection,
    className = '',
    scroll,
    rowKey,
    expandable,
    title,
    size,
}: THTableProps): ReactElement => {
    return (
        <Table
            title={title}
            dataSource={dataSource}
            columns={columns}
            loading={loading}
            pagination={false}
            rowSelection={rowSelection}
            className={classList('custom-table', className)}
            rowClassName="custom-table__row"
            scroll={{ ...defaultScroll, ...scroll }}
            rowKey={rowKey}
            expandable={expandable}
            size={size}
        />
    );
};

export default THTable;
